import { render, staticRenderFns } from "./personal-user-password.vue?vue&type=template&id=56bb9f34&"
import script from "./personal-user-password.vue?vue&type=script&lang=js&"
export * from "./personal-user-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\eoninnovaction\\Development\\administracion\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bb9f34')) {
      api.createRecord('56bb9f34', component.options)
    } else {
      api.reload('56bb9f34', component.options)
    }
    module.hot.accept("./personal-user-password.vue?vue&type=template&id=56bb9f34&", function () {
      api.rerender('56bb9f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/components/admin-personal/personal-profile-full/personal-user-password/personal-user-password.vue"
export default component.exports